import { useCallback, useEffect, useState } from 'react';

import { ensureLibPhonenumberLoaded } from 'apps/auth/helpers/libphonenumberLoader';

interface FormatterResult {
    ready: boolean;
    formatIntlPhoneNumber: (rawNumber: string, iso2: string) => string;
}

type WindowWithLibphone = Window & { libphonenumber?: { parsePhoneNumber: (value: string, iso2: string) => { formatInternational: () => string } } };

export const useLibPhonenumberFormatter = (): FormatterResult => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        void (async () => {
            const loaded = await ensureLibPhonenumberLoaded();
            if (!cancelled) {
                setReady(Boolean(loaded));
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const formatIntlPhoneNumber = useCallback(
        (rawNumber: string, iso2: string) => {
            const libWindow = window as WindowWithLibphone;
            if (!ready || !libWindow.libphonenumber || !rawNumber || !iso2) {
                return rawNumber;
            }
            try {
                const lib = libWindow.libphonenumber;
                const phoneNumber = lib.parsePhoneNumber(`+${rawNumber}`, iso2.toUpperCase());
                return phoneNumber?.formatInternational() ?? rawNumber;
            } catch {
                return rawNumber;
            }
        },
        [ready],
    );

    return { ready, formatIntlPhoneNumber };
};
